/** Default public-site favicon assets (index.html defaults). */
export const SITE_FAVICON = {
  ico: '/favicon.ico',
  png32: '/favicon-32x32.png',
  png16: '/favicon-16x16.png',
  apple: '/apple-touch-icon.png'
}

/** Brand olive green — matches --color-primary-darkGreen in index.css */
export const HUB_BRAND_GREEN = '#486039'

const HUB_FAVICON_SVG_MARKUP = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="${HUB_BRAND_GREEN}"/><rect x="10" y="8" width="3" height="16" fill="#fff"/><rect x="19" y="8" width="3" height="16" fill="#fff"/><rect x="10" y="14" width="12" height="4" fill="#fff"/></svg>`

/** Inline SVG favicon — avoids browser file cache for hub routes */
export const HUB_FAVICON_DATA_URI = `data:image/svg+xml,${encodeURIComponent(HUB_FAVICON_SVG_MARKUP)}`

/** VIVA HUB admin area favicon assets. */
export const HUB_FAVICON = {
  svg: '/img/hub/hub-favicon.svg',
  ico: '/img/hub/hub-favicon.ico',
  png32: '/img/hub/hub-favicon-32x32.png',
  png16: '/img/hub/hub-favicon-16x16.png',
  apple: '/img/hub/hub-apple-touch-icon.png'
}

export const HUB_DOCUMENT_TITLE = 'VIVA HUB'
export const SITE_DOCUMENT_TITLE = 'VIVA Psychotherapy - Mental Health Counseling'

export function isHubAreaPath (pathname) {
  return pathname.startsWith('/hub') || pathname.startsWith('/scheduler')
}
